import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Typography
} from '@mui/material';

import { useUpdatePreferences } from '@/pages/Dashboard/DashboardMCSC/DashboardMCSC.store';

import useStyles from './MCSCSplashPage.styles';

const MCSCSplashPage = () => {
  const { classes } = useStyles();
  const { mutate: updatePreferences } = useUpdatePreferences();

  return (
    <div className={classes.cardBackground}>
      <Card className={classes.card}>
        <CardHeader
          slotProps={{ title: { variant: 'h5' } }}
          className={classes.cardHeader}
          title="My CyberScorecard"
        />
        <CardContent>
          <Typography sx={{ fontSize: '1.2rem' }} variant="h5">
            Explore Your Risk Posture Like Never Before
          </Typography>
          <Typography className={classes.cardText}>
            See what you&apos;re missing with MyCyberScorecard — a powerful
            guided assessment and risk tracking dashboard designed to help
            organizations align with leading frameworks like NIST, CMMC, HIPAA,
            and more.
          </Typography>
          <Typography className={classes.cardText}>
            Quickly identify gaps, monitor improvements over time, and
            prioritize remediation efforts — all from within Scope.
          </Typography>
          <br />
          <Typography sx={{ fontSize: '1.2rem' }} variant="h5">
            This feature is available to customers who subscribe to
            MyCyberScorecard.
          </Typography>
          <Typography className={classes.cardText}>
            Click{' '}
            <a
              href="https://www.pondurance.com/mycyberscorecard"
              target="_blank"
              rel="noreferrer"
              className={classes.clickHereText}
            >
              here
            </a>{' '}
            to learn more about MyCyberScorecard.
          </Typography>
          <br />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              onClick={() =>
                updatePreferences({ show_mcsc_splash_page: false })
              }
            />
            <Typography className={classes.checkBoxText}>
              Do not show this page again
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
};

export default MCSCSplashPage;
